import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
import { noop } from "lodash-es";
export const useAdditionalOrfStartCodonsToggle = createAction(
  "useAdditionalOrfStartCodonsToggle",
  noop
);
export default createReducer(
  {
    [useAdditionalOrfStartCodonsToggle]: (state) => {
      return !state;
    }
  },
  false
);
